import {
    IntentKind,
    makeIntentBuilderFunction,
} from '@jet-app/music-classical/intents';
import type { PaginationIntent } from '../../common/pagination-invalidation-intent';

export const makeSeeAllPaginationIntent =
    makeIntentBuilderFunction<PaginationIntent>(IntentKind.SEE_ALL_PAGINATION);
